import { render } from "./pc_report_input_past_component.vue?vue&type=template&id=467f27a8&scoped=true"
import script from "./pc_report_input_past_component.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_report_input_past_component.vue?vue&type=script&scoped=true&lang=js"

import "./pc_report_input_past_component.vue?vue&type=style&index=0&id=467f27a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467f27a8"]])

export default __exports__